import React, {useEffect, useRef, useState} from 'react';
import {
    FormRenderData,
    Module,
    ModalSize,
    FilterSelectorValuesParams,
    FieldFValue,
    ResultsList,
    FilterState,
    Button,
    ScreenTypes,
} from '@cuatroochenta/co-admin-react-library';
import './res/scss/custom-styles.scss'
import '@cuatroochenta/co-admin-react-library/lib/index.css';
import DeaMapList from './modules/dea/DeaMapList';
import {GoogleMap} from './components/googleMap/GoogleMap';

export const App = ({}): React.ReactElement => {

    const [showMapView, setShowMapView] = useState<boolean>(false);
    const showMapViewRef = useRef(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setShowMapView(showMapViewRef.current);
        }, 1000)

        return () => clearInterval(interval)
    }, [showMapViewRef.current]);

    const beforeFormView = (entity: string, type: string, data: FormRenderData): React.ReactNode => {
        return null;
    };

    const afterList = (entity: string, type: ScreenTypes, list: ResultsList, filter: FilterState): React.ReactNode => {
        if (
            entity !== 'dea' ||
            (Object.keys(list).length === 0) ||
            !showMapViewRef.current ||
            (type !== ScreenTypes.LIST)
        ) {
            return;
        }

        return <DeaMapList filter={filter}/>;
    };

    const afterFormView = (entity: string, type: string, data: FormRenderData, changeField: (value: any, field: string) => void): React.ReactNode => {
        const entitiesWithMap = ['user', 'dea', 'building', 'userlocationlog', 'emergency', 'appinfo'];
        const showMapWhenCreateEntity = ['appInfo', 'user', 'dea', 'emergency'];
        const dataFields = data.fields;
        if (
            !entitiesWithMap.includes(entity) ||
            !data || !data.fields ||
            (entity === 'appinfo' && dataFields.contactLocationLatitude === undefined) ||
            (!showMapWhenCreateEntity.includes(entity) && dataFields.locationLatitude === undefined)
        ) {
            return;
        }

        let latitude = 0;
        let longitude = 0;
        let zoom;
        if (
            (dataFields.locationLatitude && dataFields.locationLongitude) ||
            (dataFields.contactLocationLatitude && dataFields.contactLocationLongitude)
        ) {
            latitude = (dataFields.locationLatitude || dataFields.contactLocationLatitude) as unknown as number;
            longitude = (dataFields.locationLongitude || dataFields.contactLocationLongitude) as unknown as number;
        } else {
            zoom = 2;
        }

        return (
            <GoogleMap
                coordinates={[{latitude: latitude, longitude: longitude, title: 'Ubicación seleccionada'}]}
                draggableCoordinates={type !== 'view'}
                handleChangePosition={(lat, lng) => {
                    changeField(lat, 'locationLatitude');
                    changeField(lng, 'locationLongitude');
                }}
                zoom={zoom}
            />
        );
    };

    const getSizeFilterModal = (entity: string): ModalSize | undefined => {
        if (entity === 'user') {
            return ModalSize.LG;
        }
    };

    const filterSelectorValues = (
        filterSelectorValuesParams: FilterSelectorValuesParams
    ): FieldFValue[] => {
        return filterSelectorValuesParams.values;
    };

    const customScreenButtonList = (entity: string, type: string, data: any): React.ReactNode => {
        if (entity !== 'dea' || type !== 'list') {
            return;
        }
        return (
            <Button
                content={showMapViewRef.current ? 'vista lista' : 'vista mapa'}
                onClick={() => {
                    showMapViewRef.current = !showMapViewRef.current;
                }
                }
            />
        )
    };

    return (
        <Module
            actions={[]}
            afterFormView={afterFormView}
            beforeFormView={beforeFormView}
            afterList={afterList}
            locale={'es'}
            getSizeFilterModal={getSizeFilterModal}
            filterSelectorValues={filterSelectorValues}
            customScreenButtonList={customScreenButtonList}
            customListView={showMapViewRef.current}
        />
    );

}
